module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tutorials.json
// module id = 377
// module chunks = 22617492684367